import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option"]

  connect() {
    this.refresh()
  }

  select() {
    this.refresh()
  }

  refresh() {
    this.optionTargets.forEach(option => {
      const selected = option.querySelector("input:checked") !== null

      option.classList.toggle("btn-success", selected)
      option.classList.toggle("btn-light", !selected)
    })
  }
}
